import { useState, useCallback } from 'react';

const FORM_SUBMIT_ADDR = 'https://readdy.ai/api/form/d9spokd8o1vn02ekujs0';

export default function ContactSection() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [statusMsg, setStatusMsg] = useState('');

  const handleSubmit = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setStatusMsg('感谢你的留言，我们会尽快回复！');
      return;
    }

    setStatus('loading');
    setStatusMsg('');

    try {
      const formData = new FormData(form);
      formData.delete('phone_alt');
      const response = await fetch(FORM_SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setStatusMsg('感谢你的留言，我们会尽快回复！');
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试。';
        if (typeof msg === 'string' && msg.toLowerCase().includes('spam')) {
          setStatus('success');
          setStatusMsg('感谢你的留言，我们会尽快回复！');
        } else {
          setStatus('error');
          setStatusMsg(msg);
        }
      }
    } catch {
      setStatus('error');
      setStatusMsg('网络错误，请检查连接后重试。');
    }
  }, []);

  return (
    <section id="contact" className="py-14 md:py-20">
      <div className="text-center mb-10 md:mb-14">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
          联系我们
        </h2>
        <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
          有任何问题、建议或合作意向，欢迎给我们留言
        </p>
      </div>

      <div className="max-w-lg mx-auto px-4 md:px-6">
        <form onSubmit={handleSubmit} data-readdy-form="true" className="space-y-5">
          <input
            type="text"
            name="phone_alt"
            className="spm-field"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
          <div>
            <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
              你的名字
            </label>
            <input
              id="contact-name"
              name="name"
              type="text"
              required
              className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-all"
              placeholder="请输入你的名字"
            />
          </div>
          <div>
            <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
              电子邮箱
            </label>
            <input
              id="contact-email"
              name="email"
              type="email"
              required
              className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-all"
              placeholder="your@email.com"
            />
          </div>
          <div>
            <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
              主题
            </label>
            <input
              id="contact-subject"
              name="subject"
              type="text"
              required
              className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-all"
              placeholder="请输入主题"
            />
          </div>
          <div>
            <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
              留言内容
            </label>
            <textarea
              id="contact-message"
              name="message"
              rows={5}
              required
              maxLength={500}
              className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-all resize-none"
              placeholder="请写下你想对我们说的话（不超过500字）"
            ></textarea>
          </div>

          {statusMsg && (
            <div
              className={`text-sm px-4 py-3 rounded-lg ${
                status === 'success'
                  ? 'bg-accent-50 text-accent-700 border border-accent-200'
                  : 'bg-primary-50 text-primary-700 border border-primary-200'
              }`}
            >
              {statusMsg}
            </div>
          )}

          <button
            type="submit"
            disabled={status === 'loading'}
            className="w-full px-6 py-3 bg-primary-500 text-white rounded-lg text-sm font-medium hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            {status === 'loading' ? (
              <>
                <i className="ri-loader-4-line animate-spin"></i>
                发送中...
              </>
            ) : (
              <>
                发送留言
                <i className="ri-send-plane-line"></i>
              </>
            )}
          </button>
        </form>
      </div>
    </section>
  );
}